import { SipProfileAPI } from '@weave/schema-gen-ts/dist/schemas/phone/sip-profiles/v1/sip_profiles.pb';
import { bindHTTP } from '@frontend/schema';

const SchemaSipProfileService = bindHTTP(SipProfileAPI);

export default SchemaSipProfileService;
